import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, Typography } from '@material-ui/core';
import { BASE_URL, IMAGE_PATHS } from '../../../constants/paths.constants';
import { axuminTheme, poslumaTheme } from '../../../app/theme';
import LEARNING_CHECK from '../../../constants/learningCheck.constants';
import SingleQuestion from './SingleQuestion';

const useStyles = makeStyles(() => ({
  container: {
    paddingBottom: 50,
  },
  header: {
    display: 'flex',
    marginBottom: 50,
  },
  icon: {
    height: 119,
    paddingRight: 66,
    marginBottom: 10,
  },
  toBottom: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  heading: {
    margin: 0,
  },
}));

type LearningCheckQuestionsProps = {
  module: string;
  page: number;
  trainingId: number;
  setNextDisabled: (disabled: boolean) => void;
};

const LearningCheckQuestions = ({
  module,
  trainingId,
  page,
  setNextDisabled,
}: LearningCheckQuestionsProps): JSX.Element => {
  const classes = useStyles();
  const questionsArray = LEARNING_CHECK[module][page.toString()];
  const [clickedArray, setClickedArray] = useState(new Array(questionsArray.length).fill(false));
  const theme = trainingId === 1 ? axuminTheme : poslumaTheme;
  const learningCheckPath =
    IMAGE_PATHS.LEARNING_CHECK_ICONS[trainingId.toString() as keyof typeof IMAGE_PATHS.CASE_STUDY];

  const clickedCheckAnswer = (index: number) => {
    const newArray = [...clickedArray];
    newArray[index] = true;
    setClickedArray(newArray);
  };

  useEffect(() => {
    // If all the LC questions have been checked, we should stop disabling the Next Button on LearningPage
    if (!clickedArray.some((entry) => entry === false)) {
      setNextDisabled(false);
    }
  }, [clickedArray, setNextDisabled]);

  return (
    <MuiThemeProvider theme={theme}>
      <div className={classes.container}>
        <div className={classes.header}>
          <img
            className={classes.icon}
            src={`${BASE_URL}${learningCheckPath.LEARNING_CHECK_ICON.path}`}
            alt={`${learningCheckPath.LEARNING_CHECK_ICON.alt}`}
          />
          <div className={classes.toBottom}>
            <Typography variant="h1" className={classes.heading}>
              Learning Check Question
              {questionsArray.length > 1 ? 's' : ''}
            </Typography>
          </div>
        </div>
        {questionsArray?.length > 0 &&
          questionsArray.map((thisQuestion, index) => (
            <SingleQuestion
              key={thisQuestion.number}
              thisQuestion={thisQuestion}
              clickedCheckAnswer={() => clickedCheckAnswer(index)}
              module={module}
              page={page}
            />
          ))}
      </div>
    </MuiThemeProvider>
  );
};

export default LearningCheckQuestions;
